// Catches a crash inside a popup so the page behind it keeps working, and
// shows what went wrong (to pass on) instead of a blank screen.

import { Component, type ReactNode } from 'react';
import { Button, Modal } from './ui';

interface State { error: Error | null }

export class PopupErrorBoundary extends Component<{ children: ReactNode; onReset?: () => void }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error('Popup crashed:', error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const close = () => { this.setState({ error: null }); this.props.onReset?.(); };
    return (
      <Modal open onClose={close} title="Something went wrong"
        footer={<Button variant="secondary" onClick={close}>Close</Button>}>
        <p style={{ fontSize: 13, color: 'var(--text-2)', marginTop: 0 }}>
          This window hit an error. The page behind it is fine. Please send this message to support:
        </p>
        <pre style={{
          fontSize: 11.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0,
          background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)',
          padding: '10px 12px', color: 'var(--danger)', maxHeight: 260, overflow: 'auto',
        }}>
          {error.message}{error.stack ? `\n\n${error.stack.split('\n').slice(0, 6).join('\n')}` : ''}
        </pre>
      </Modal>
    );
  }
}
